export default [
  { id: 'date', label: 'Date' },
  { id: 'ualbkrea', label: 'U-albumin/U-kreatinin' },
  { id: 'creatinine', label: 'Kreatinin' },
  { id: 'egfr', label: 'eGFR' },
];
